import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { normalize } from "common/lib/normalize";
import { getAgencies } from "common/services/agencies.service";

const SelectAgency = ({
  validation,
  setLoading,
  label,
  index,
}: {
  validation: any;
  setLoading: any;
  label?: any;
  index: number;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.classifiedInformation?.[index]?.reportingAgency &&
        validation.errors.classifiedInformation?.[index]?.reportingAgency
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.classifiedInformation?.[index]?.reportingAgency &&
          validation.errors.classifiedInformation?.[index]?.reportingAgency
            ? "red"
            : "#ced4da",
      },
    }),
  };
  const [data, setData] = React.useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getAgencies({
          pagination: {
            page: 1,
            pageSize: 10000,
          },
          filters: {
            category: {
              $null: false,
            },
          },
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label
        htmlFor={`classifiedInformation[${index}].reportingAgency`}
        className="form-label"
      >
        {label ? label : "Agency"}
      </Label>
      <Select
        name={`classifiedInformation[${index}].reportingAgency`}
        id={`classifiedInformation[${index}].reportingAgency`}
        value={
          validation.values.classifiedInformation[index]?.reportingAgency?.value
            ? validation.values.classifiedInformation[index]?.reportingAgency
            : null
        }
        placeholder="Select reporting agency"
        onChange={(value: any) => {
          validation.setFieldValue(
            `classifiedInformation[${index}].reportingAgency`,
            value
          );
        }}
        options={options}
        onBlur={() =>
          validation.setFieldTouched(
            `classifiedInformation[${index}].reportingAgency`,
            true
          )
        }
        className={
          validation.touched.classifiedInformation?.[index]?.reportingAgency &&
          validation.errors.classifiedInformation?.[index]?.reportingAgency
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isClearable={true}
      />
      <FormFeedback>
        {
          validation.errors.classifiedInformation?.[index]?.reportingAgency
            ?.value
        }
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectAgency;
